/**
 * @atlas
 * @kind constant
 * @partOf primitive:shared, primitive:websockets
 * @uses none
 */
// gloss
export const WSActor = {
  FanUsers: 'FanUsers',
  BrandUsers: 'BrandUsers',
  prospect: 'prospect',
} as const;

// gloss
export type WSActor = (typeof WSActor)[keyof typeof WSActor];
